import { useDispatch } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { RxCross2 } from 'react-icons/rx';

import { CustomLoader } from '../../../services/Reducer';
import apiClient from '../../../api/apiClient';
import authServices from '../../../services/AuthServices';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

const Add_table = ({ show, toggle, refreshData, AddcurrentPage }) => {
  const token = authServices.getToken();

  const [data, setData] = useState([]);
  const fetchSubCommodities = async () => {
    try {
      const response = await apiClient.get(`/api/admin/sub_commodity/getAll`,
        {
          params: {
            pageNumber: 0,
            pageSize: 200
          },
          headers: {
            'access_token': token,
          }
        }
      );
      setData(response.data.data.records);

    } catch (err) {
      console.error('Error fetching data:', err);
    }
  };

  const filteredData = Array.from(
    new Map(data.map((item) => [item.subCommodity, item])).values()
  );

  const validData = filteredData.filter((item) => item.subCommodity);

  const [data2, setData2] = useState([]);
  const fetchUnit = async () => {
    try {
      const response = await apiClient.get(`/api/admin/unit/getAll`,
        {
          params: {
            pageNumber: 0,
            pageSize: 200
          },
          headers: {
            'access_token': token,
          }
        }
      );
      setData2(response.data.data.records);

    } catch (err) {
      console.error('Error fetching data:', err);
    }
  };

  const filteredData2 = Array.from(
    new Map(data2.map((item) => [item.name, item])).values()
  );

  const validData2 = filteredData2.filter((item) => item.name);


  const [formData, setFormData] = useState({

    subSubCommodity: '',
    subCommodity: null,
    unit: null,

  });
  const [errors, setErrors] = useState({}); // Error state
  const dispatch = useDispatch();

  const loader = (display) => {
    dispatch(CustomLoader(display));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    // Clear the error for the field being edited
    setErrors({ ...errors, [name]: '' });
  };

  const validateForm = () => {
    let formErrors = {};

    if (formData.subSubCommodity === '') {
      formErrors.subSubCommodity = 'subSubCommodity cannot be empty';
    }
    if (formData.subCommodity === null) {
      formErrors.subCommodity = 'subCommodity cannot be empty';
    }
    if (formData.unit === null) {
      formErrors.unit = 'unit cannot be empty';
    }

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0; // No errors
  };

  // console.log(formData)

  const AllData = {
    subCommodityId: {
      id: formData.subCommodity 
    },
    unitId: {
      id: formData.unit
    },
    subSubCommodity: formData.subSubCommodity,
  }

  // console.log("AllData",AllData)

  const handleSubmit = async (e) => {
    // e.preventDefault();
    if (!validateForm()) {
      return; // Stop submission if there are validation errors
    }

    loader('enable');

    try {

      const response = await apiClient.post('/api/admin/sub_sub_commodity/add', AllData, {

        headers: {
          'access_token': token,
        },

      });

      if (response.data.Status === "SUCCESS") {
        setFormData({
          subSubCommodity: '',
          subCommodity: null,
          unit: null,


        });
      }
      else {
        console.log(response.data.message)
      }
    }
    catch (error) {
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    }
    finally {
      refreshData(AddcurrentPage);
      loader('disable');
      toggle(); // Close the modal after submission
      // window.location.reload();
    }
  };

  useEffect(() => {
    fetchSubCommodities()
    fetchUnit()
  }, [])

  return (
    <>
      {show && (
        <>
          <div className="modal fade show d-block" id="exampleModalScrollable" tabIndex={-1} role="dialog" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true">
            <div className="modal-dialog modal-dialog-scrollable">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalScrollableTitle">Add Sub_Sub_Commodity</h5>
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={toggle} >< RxCross2 /></button>
                </div>
                <div className="modal-body-custom">
                  <form >

                    <div className='row w-100'>
                      <div className="spacing w-50 d-inline-block">


                        <label htmlFor="unit" className="label-custom">Unit</label>
                        {/* <Autocomplete
                        id="unit"
                        options={validData2} // Options array
                        getOptionLabel={(option) => option.name || ''} // Displayed label
                        sx={{ width: '100%' }}
                        value={
                          data2.find((item) => item.name === formData.unit) || null
                        }
                        onChange={(event, newValue) => {
                          setFormData({
                            ...formData,
                            unit: newValue?.id || '',
                          });
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            // label="Sub Commodity"
                            variant="outlined"
                            className={`input-custom ${errors.unit ? 'input-error' : ''}`}
                          />
                        )}
                      /> */}

                        <Autocomplete
                          className={` ${errors.unit ? 'input-error' : ''}`}
                          disablePortal
                          options={validData2} // Full user object
                          getOptionLabel={(option) => option.name} // Show 'name' in dropdown
                          getOptionSelected={(option, value) => option.id === value.id} // Ensure unique selection
                          renderInput={(params) => <TextField {...params} label="" />}
                          onChange={(event, value) => {
                            if (value) {
                              setFormData({ ...formData, unit: value.id }); // Save 'id' in state 
                            } else {
                              setFormData({ ...formData, unit: "" }); // Reset state 
                            }
                          }}
                          renderOption={(props, option) => (
                            <li {...props} key={option.id}>
                              {option.name}
                            </li>
                          )}
                          // Scroll enable kare inline style ke sath
                          componentsProps={{
                            paper: {
                              style: {
                                maxHeight: '120px', // Dropdown ki maximum height
                                overflowY: 'auto',  // Scroll enable karega
                              },
                            },
                          }}
                        />
                      </div>

                      <div className="spacing w-50 d-inline-block">

                        <label htmlFor="subCommodity" className="label-custom">Sub Commodity</label>
                        {/* <Autocomplete
                          id="subCommodity"
                          options={validData} // Options array
                          getOptionLabel={(option) => option.subCommodity || ''} // Displayed label
                          sx={{ width: '100%' }}
                          value={
                            data.find((item) => item.subCommodity === formData.subCommodity) || null
                          }
                          onChange={(event, newValue) => {
                            setFormData({
                              ...formData,
                              subCommodity: newValue?.id || '',
                            });
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              // label="Sub Commodity"
                              variant="outlined"
                              className={`input-custom ${errors.subCommodity ? 'input-error' : ''}`}
                            />
                          )}
                        /> */}

                        <Autocomplete
                          className={` ${errors.subCommodity ? 'input-error' : ''}`}
                          disablePortal
                          options={validData} // Full user object
                          getOptionLabel={(option) => option.subCommodity} // Show 'name' in dropdown
                          getOptionSelected={(option, value) => option.id === value.id} // Ensure unique selection
                          renderInput={(params) => <TextField {...params} label="" />}
                          onChange={(event, value) => {
                            if (value) {
                              setFormData({ ...formData, subCommodity: value.id }); // Save 'id' in state
                            } else {
                              setFormData({ ...formData, subCommodity: "" }); // Reset state
                            }
                          }}
                          // Key attribute setup using 'id'
                          renderOption={(props, option) => (
                            <li {...props} key={option.id}>
                              {option.subCommodity}
                            </li>
                          )}
                          // Scroll enable kare inline style ke sath
                          componentsProps={{
                            paper: {
                              style: {
                                maxHeight: '120px', // Dropdown ki maximum height
                                overflowY: 'auto',  // Scroll enable karega
                              },
                            },
                          }}
                        />

                      </div>

                    </div>

                    <div className="spacing" style={{ width: '96.50%' }}>
                      <label htmlFor="subSubCommodity" className="label-custom">Sub Sub Commodity</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.subSubCommodity ? 'input-error' : ''}`}
                        id="subSubCommodity"
                        name="subSubCommodity"
                        value={formData.subSubCommodity}
                        onChange={handleChange}
                      />

                    </div>

                  </form>
                </div>

                <div className="modal-footer">

                  <button type="button" style={{ backgroundColor: '#F0F0F0', color: '#000', fontWeight: '500', border: "1px solid #d7dde2" }} className="btn " data-bs-dismiss="modal" onClick={toggle}>
                    Close
                  </button>
                  <button type="button" style={{ color: 'white', fontWeight: '500' }} className="btn btn-primary" onClick={handleSubmit}>
                    Submit
                  </button>

                </div>
              </div>
              {/* /.modal-content */}
            </div>
            {/* /.modal-dialog */}
          </div>
          {/* /.modal */}
        </>
      )}
    </>
  );
};

export default Add_table;
